import { CSSProperties, forwardRef } from 'react';
import * as S from './styles';
import { StaticImageData } from 'next/image';
import Text from '../Text';
import Cartaz, { TamanhosCartaz } from '../Cartaz';
import NotasEmLinha from '@/components/molecules/NotasEmLinha';
import { theme } from '@/styles/theme';

export type TituloGenericoProps = {
  $image?: string | StaticImageData;
  $nome?: string;
  $corNome?: string;
  $style?: CSSProperties;
  $link?: string;
  $notaEstrela?: number;
  $notaChippu?: number;
  $disabled?: boolean;
  $posicao?: number;
  $tamanhoCartaz?: TamanhosCartaz;
  $eventoAnalytics?: () => void;
};

// TODO: refatorar nome para fichaGenerica
const TituloGenerico = forwardRef<HTMLDivElement, TituloGenericoProps>(
  (props, ref) => {
    const {
      $image,
      $nome,
      $corNome,
      $link = '',
      $disabled = false,
      $notaEstrela,
      $notaChippu,
      $style,
      $posicao,
      $tamanhoCartaz = 'medio',
      $eventoAnalytics,
    } = props;

    return (
      <S.Container
        onClick={$eventoAnalytics}
        ref={ref}
        style={$style}
        $ranking={!!$posicao}
        $tamanhoCartaz={$tamanhoCartaz}
        {...props}
      >
        <S.ContainerTitulo
          style={{
            pointerEvents: $disabled ? 'none' : 'auto',
          }}
          $ranking={!!$posicao}
          onClick={() => (window.location.href = $link)}
        >
          <Cartaz
            alt={`cartaz do filme ou série ${$nome}`}
            src={$image ?? ''}
            $tamanho={$tamanhoCartaz}
          />
          <S.ContainerInformacoesTitulo $ranking={!!$posicao}>
            <S.ContainerRanking>
              {$posicao ? (
                <Text
                  $size={10}
                  $color={'neutral'}
                  $weight="bold"
                  $align="left"
                  $highContrast={true}
                  $text={$posicao}
                  $quebraTexto={false}
                />
              ) : null}
              {$nome ? (
                <S.NomeTitulo>
                  <Text
                    $size={3}
                    $color={$corNome || 'neutral'}
                    $weight="regular"
                    $align="left"
                    $highContrast={true}
                    $text={$nome}
                    $utilizarReticencias
                    style={{
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  />
                </S.NomeTitulo>
              ) : null}
            </S.ContainerRanking>
            {$notaEstrela != null || $notaChippu != null ? (
              <NotasEmLinha
                $notaEstrela={$notaEstrela}
                $notaChippu={$notaChippu}
                $colorido
                style={{
                  marginTop: theme.spacing[1],
                }}
              />
            ) : null}
          </S.ContainerInformacoesTitulo>
        </S.ContainerTitulo>
      </S.Container>
    );
  },
);

TituloGenerico.displayName = 'TituloGenerico';

export default TituloGenerico;
